import Phaser from "phaser";
import { FishBase } from "./FishBase";

export class MuskyAI extends FishBase {
    private readonly player: Phaser.Physics.Arcade.Sprite;
    private roamAngle = Phaser.Math.FloatBetween(0, Math.PI * 2);

    constructor(scene: Phaser.Scene, x: number, y: number, player: Phaser.Physics.Arcade.Sprite) {
        super(scene, x, y, {
            species: "Musky",
            textureKey: "musky",
            pointValue: 50,
            swimSpeed: 130,
        });
        this.player = player;
    }

    override update(): void {
        const fleeRadius = 260;
        const distanceToPlayer = Phaser.Math.Distance.Between(this.x, this.y, this.player.x, this.player.y);
        if (distanceToPlayer < fleeRadius) {
            const away = new Phaser.Math.Vector2(this.x - this.player.x, this.y - this.player.y).normalize();
            const vx = away.x * (this.swimSpeed * 1.75);
            const vy = away.y * (this.swimSpeed * 1.75);
            this.swimWithBias(vx, vy, this.swimSpeed * 1.75);
            return;
        }

        this.roamAngle += 0.01;
        const vx = Math.cos(this.roamAngle) * this.swimSpeed * 0.55;
        const vy = Math.sin(this.roamAngle) * this.swimSpeed * 0.55;
        this.swimWithBias(vx, vy, this.swimSpeed * 0.55);
        this.roamAngle = this.rotation;
    }
}
